var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-5 pt-4" }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.presentPractices && _vm.hasPrev
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-5 pt-4 mt-5 vaillantCont"
              },
              [
                _c("h4", { staticClass: "black center widthFull mt-4" }, [
                  _vm._v("\n        Non hai preventivi accettati\n      ")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-lg btnYellow mt-2",
                    attrs: { to: "/offerte" }
                  },
                  [_vm._v("Gestione Preventivi")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.presentPractices && !_vm.hasPrev
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-5 pt-4 mt-5 vaillantCont"
              },
              [
                _c("h4", { staticClass: "black center widthFull mt-4" }, [
                  _vm._v("\n        Non creato ancora nessuna pratica\n      ")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-lg btnYellow mt-2",
                    attrs: { to: "/calcolatore" }
                  },
                  [_vm._v("Crea Pratica")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-3 pt-3 align-items-end"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "\n          col-4 col-md-3\n          pb-0\n          pl-1\n          pr-1\n          pl-md-5\n          pr-md-5\n          d-none d-md-block\n        "
                  },
                  [
                    _vm.totCash
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: parseFloat(_vm.countCashClient),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": 100
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v("€")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.countCashClient
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("small", [_vm._v("Fatturato verso Clienti")])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-5 col-md-3 pb-0 pr-0 pl-0" },
                  [
                    _vm.totCash
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: parseFloat(_vm.countCashInst),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": 100
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v("€")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(_vm.countCashInst)
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("small", [_vm._v("Credito Totale")])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "\n          col-4 col-md-3\n          center\n          pl-1\n          pr-1\n          pl-md-5\n          pr-md-5\n          d-none d-md-block\n        "
                  },
                  [
                    _vm.totCash
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value:
                                parseFloat(_vm.countCashClient) +
                                parseFloat(_vm.countCashInst),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": 100
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v("€")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        parseFloat(_vm.countCashClient) +
                                          parseFloat(_vm.countCashInst)
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("small", [_vm._v("Fatturato Totale")])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 col-md-3" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.filterValues($event)
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "text-center grey pb-0 mb-0" }, [
                        _vm._v("Ricerca Pratica")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mb-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter,
                              expression: "filter"
                            }
                          ],
                          staticClass: "form-control seachMobButton",
                          attrs: {
                            type: "text",
                            placeholder: "Numero Pratica o Cognome..."
                          },
                          domProps: { value: _vm.filter },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.filter = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "input-group-append d-none" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.filterValues($event)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                CERCA\n              "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices && _vm.hasPrev
          ? _c(
              "div",
              {
                staticClass:
                  "\n        row\n        mr-0\n        ml-0\n        justify-content-center\n        pb-0\n        pt-0\n        align-items-end\n        bgWhite\n        mb-3\n      "
              },
              [
                _c("div", { staticClass: "col-6 col-md-3 center Bold" }, [
                  _c("h5", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm._f("formatNumber")(_vm.totUserReceived)) +
                          " €"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Credito Ceduto*")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 col-md-3 center Bold" }, [
                  _c("h5", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm._f("formatNumber")(_vm.totAmountBefore10)) +
                          " €"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Credito in maturazione")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 col-md-3 center Bold" }, [
                  _c("h5", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm._f("formatNumber")(_vm.totAmountAfter10)) +
                          " €"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Credito Cedibile*")])
                ]),
                _vm._v(" "),
                _vm._m(1)
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              {
                staticClass: "row justify-content-center align-items-end mt-5"
              },
              [
                _c(
                  "div",
                  { staticClass: "col-4 col-md-2 text-center text-md-left" },
                  [
                    _c(
                      "div",
                      { staticClass: "buttonTextCont widthfull lightRight" },
                      [
                        _c(
                          "h1",
                          { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                          [_c("b", [_vm._v(_vm._s(_vm.countErrorPractice))])]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-danger btn-sm uppercase widthFull",
                        on: {
                          click: function($event) {
                            _vm.filter = "Pratiche con Anomalie"
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "exclamation-triangle", size: "sm" }
                        }),
                        _c("span", { staticClass: "d-none d-md-inline" }, [
                          _vm._v("\n            Con Anomalie")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-md-2 text-left text-center text-md-left"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "buttonTextCont widthfull lightGreen" },
                      [
                        _c(
                          "h1",
                          { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                          [_c("b", [_vm._v(_vm._s(_vm.countPractices))])]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-primary btn-blue btn-sm uppercase widthFull",
                        on: {
                          click: function($event) {
                            _vm.filter = ""
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "white",
                          attrs: { icon: "clipboard-list", size: "sm" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "d-none d-md-inline white" },
                          [_vm._v(" Tutte le pratiche")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-4 col-4 col-md-2 text-center text-md-left"
                  },
                  [
                    _c("div", { staticClass: "buttonTextCont widthfull" }, [
                      _c(
                        "h1",
                        { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                        [_c("b", [_vm._v(_vm._s(_vm.countStep1Practice))])]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-info btn-sm uppercase widthFull",
                        on: {
                          click: function($event) {
                            _vm.filter = "Step1"
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "balance-scale", size: "sm" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "d-none d-md-inline" }, [
                          _vm._v(" Carica Docum...")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left" }, [
                  _c("div", { staticClass: "buttonTextCont widthfull" }, [
                    _c(
                      "h1",
                      { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                      [_c("b", [_vm._v(_vm._s(_vm.countStep2Practice))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-sm uppercase widthFull",
                      on: {
                        click: function($event) {
                          _vm.filter = "Step2"
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "balance-scale", size: "sm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-md-inline white" }, [
                        _vm._v(" Verifica")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left" }, [
                  _c("div", { staticClass: "buttonTextCont widthfull" }, [
                    _c(
                      "h1",
                      { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                      [_c("b", [_vm._v(_vm._s(_vm.countStep3Practice))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-sm widthFull",
                      on: {
                        click: function($event) {
                          _vm.filter = "Step3"
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "balance-scale", size: "sm" }
                      }),
                      _vm._v(" "),
                      _vm._m(2)
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left" }, [
                  _c("div", { staticClass: "buttonTextCont widthfull" }, [
                    _c(
                      "h1",
                      { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                      [_c("b", [_vm._v(_vm._s(_vm.countStep4Practice))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-primary btn-sm uppercase btn-blue widthFull",
                      on: {
                        click: function($event) {
                          _vm.filter = "Step4"
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "euro-sign", size: "sm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-md-inline white" }, [
                        _vm._v(" BONIFICO ")
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          !_vm.showFilterText
            ? _c(
                "div",
                { staticClass: "col-md-12 col-lg-12" },
                [
                  _c(
                    "badger-accordion",
                    { key: "sdfg345", staticClass: "pb-5 mt-4" },
                    _vm._l(_vm.practicesFiltred, function(item, key) {
                      return item.status != 10
                        ? _c(
                            "badger-accordion-item",
                            { key: item.code + "_" + _vm.countloop },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-9 text-center text-md-left"
                                        },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v(
                                              "\n                    Pratica associata a\n                    "
                                            ),
                                            _c(
                                              "b",
                                              { staticClass: "underline" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.azienda_user)
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              " con PIVA\n                    "
                                            ),
                                            _c(
                                              "b",
                                              { staticClass: "underline" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.partita_iva_user
                                                  ) + " "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v("\n                    N. "),
                                            _c(
                                              "b",
                                              { staticClass: "underline" },
                                              [_vm._v(_vm._s(item.code))]
                                            ),
                                            _vm._v(
                                              " del\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .moment(item.created_at)
                                                    .format("DD-MM-YYYY HH:mm")
                                                ) +
                                                " (\n                    " +
                                                _vm._s(item.bonus) +
                                                " ) per\n                    "
                                            ),
                                            _c("b", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.client_name) +
                                                  " " +
                                                  _vm._s(item.client_lastname) +
                                                  " "
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _vm.hasPrev
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-primary m-2 btn-sm",
                                                  attrs: {
                                                    href: item.signed_order,
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: "eye",
                                                      size: "sm"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    " visualizza\n                    Preventivo Firmato\n                  "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "btn btn-primary btn-blue m-2 btn-sm",
                                              attrs: {
                                                to: {
                                                  name: "loadDocuments",
                                                  params: { item: item }
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "clipboard-check",
                                                  size: "1x"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                    Gestione Documenti\n                  "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          item.status == 1 &&
                                          item.payment_id == "0"
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-danger m-2 btn-sm",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.removePractice(
                                                        item.id,
                                                        item.code,
                                                        key
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: "trash-alt",
                                                      size: "sm"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    " Elimina\n                  "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 1
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: require("../../assets/images/traficLight_red.png")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 2 ||
                                          item.status == 3 ||
                                          item.status == 4
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: require("../../assets/images/traficLight_yellow.png")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 5
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: require("../../assets/images/traficLight_green.png")
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-7 col-md-1 center pl-md-0 pr-md-0 pt-3"
                                        },
                                        [
                                          item.enea_request == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                class: {
                                                  "bg-success": _vm.checkEneaComplate(
                                                    item.aditional_enea_data
                                                  )
                                                },
                                                attrs: {
                                                  src: require("../../assets/images/enea.png")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.to_get_cadastral_data == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                class: {
                                                  "bg-success":
                                                    item.dcast_export == "10"
                                                },
                                                attrs: {
                                                  src: require("../../assets/images/dcast.png")
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-2 center pt-3" },
                                        [
                                          item.status == 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "\n                      inline-block\n                      center\n                      relative\n                      topCust2\n                      d-none d-md-inline\n                    ",
                                                  staticStyle: {
                                                    position:
                                                      "initial !important"
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "qrcodeImg qrcodeImg2",
                                                    attrs: { src: item.qrcode }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("br")
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status != 1 &&
                                          item.ade_protocol_number
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "\n                      inline-block\n                      center\n                      relative\n                      topCust2\n                      d-md-inline\n                      pt-4 pt-md-0\n                      pb-0\n                    ",
                                                  staticStyle: {
                                                    position:
                                                      "initial !important"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "pt-0 pt-md-2 pb-md-2 bgGreen white"
                                                    },
                                                    [
                                                      _c("small", [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Protocollo AdE nr.\n                          " +
                                                              _vm._s(
                                                                item.ade_protocol_number
                                                              )
                                                          )
                                                        ])
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.status == 1 && item.hasErrors == "no"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 col-md-11 mt-3 center requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "yellow widthFull text-left"
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass: "mr-4 theme"
                                                    },
                                                    [_vm._v("Per procedere:")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "theme" },
                                                    [
                                                      _vm._v(
                                                        "\n                      Prepara e carica tutta la documentazione nella sezione\n                      GESTIONE DOCUMENTI\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.aditional_enea_data == null &&
                                      item.enea_request == "1" &&
                                      item.payment_id != "0" &&
                                      2 == 3
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-11 requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "Regular text-center h0 widthFull"
                                                },
                                                [
                                                  item.status == 2
                                                    ? _c("b", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "yellow"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Attenzione!"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " Per redigere e\n                      inviare la Pratica ENEA abbiamo necessità di ulteriori\n                      informazioni\n                    "
                                                        )
                                                      ])
                                                    : _c("b", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "yellow"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Attenzione!"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " Per redigere ed\n                      inviare la pratica ENEA avremo bisogno di ulteriori\n                      informazioni che ti chiederemo alla conclusione del Set\n                      Documentale.\n                    "
                                                        )
                                                      ]),
                                                  _vm._v(" "),
                                                  item.status == 2
                                                    ? _c(
                                                        "router-link",
                                                        {
                                                          staticClass:
                                                            "btn btn-primary m-2 btn-sm",
                                                          attrs: {
                                                            to: {
                                                              name:
                                                                "complateEneaData",
                                                              params: {
                                                                item: item
                                                              }
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      Inserisci\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.hasErrors == "yes"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 col-md-11 mt-3 center requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "red widthFull text-left"
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "widthFull mr-4"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Attenzione abbiamo rilevato seguenti anomalie:"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "red widthFull text-left pl-4"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(item.errors) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 center pt-4"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "card step-progress pt-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "step-slider" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item",
                                                      class: {
                                                        active:
                                                          item.status == 1,
                                                        "active passed":
                                                          item.status != 1
                                                      },
                                                      attrs: {
                                                        "data-id": "step1"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$router.push(
                                                            {
                                                              name:
                                                                "loadDocuments",
                                                              params: {
                                                                item: item
                                                              }
                                                            }
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 1 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(
                                                              "Carica Documentazione"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item",
                                                      class: {
                                                        notactive:
                                                          item.status == 1,
                                                        active:
                                                          item.status == 2,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2
                                                      },
                                                      attrs: {
                                                        "data-id": "step2"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 2 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v("Verifica")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item notactive",
                                                      class: {
                                                        notactive:
                                                          item.status == 2,
                                                        active:
                                                          item.status == 3,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2 &&
                                                          item.status != 3
                                                      },
                                                      attrs: {
                                                        "data-id": "step3"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 3 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(
                                                              "Accettazione cessione del credito"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item notactive",
                                                      class: {
                                                        notactive:
                                                          item.status == 3,
                                                        active:
                                                          item.status == 4,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2 &&
                                                          item.status != 3 &&
                                                          item.status != 4
                                                      },
                                                      attrs: {
                                                        "data-id": "step4"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 4 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(" Bonifico")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "step-content"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                {
                                  staticClass: "bbaLightColor",
                                  slot: "content"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-left",
                                          class: {
                                            "col-11": !_vm.hasPrev,
                                            "col-md-9": _vm.hasPrev
                                          }
                                        },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v(
                                              "\n                    Indirizzo dell'immobile\n                    "
                                            ),
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(item.building_address) +
                                                  " " +
                                                  _vm._s(item.building_civic) +
                                                  " -\n                      " +
                                                  _vm._s(item.building_zip) +
                                                  " " +
                                                  _vm._s(item.building_city) +
                                                  " (" +
                                                  _vm._s(
                                                    item.building_province
                                                  ) +
                                                  ")\n                    "
                                              )
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.hasPrev
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "col-md-3 text-left"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                { staticClass: "black pb-0" },
                                                [_vm._v("Dati dell'intervento")]
                                              ),
                                              _vm._v(
                                                "\n                  Tipo:\n                  "
                                              ),
                                              _c("b", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "uppercase Regular"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.intervention_type
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasPrev
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "col-md-3 text-left"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "black pb-0 text-left widthFull"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Da Cliente:\n                    "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      "\n                      €\n                      " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              item.total_transfer_for_client
                                                            )
                                                          )
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasPrev
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "col-md-3 text-left"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "black pb-0 text-left"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Da Cessione:\n                    "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      "\n                      €\n                      " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              item.total_transfer_for_user
                                                            )
                                                          )
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasPrev
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "col-md-3 text-left"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "black pb-0 text-left"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Totale:\n                    "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      "\n                      €\n                      " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              item.total_transfer_for_client
                                                            ) +
                                                              parseFloat(
                                                                item.total_transfer_for_user
                                                              )
                                                          )
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "badger-accordion",
                    { key: "12312412512354134", staticClass: "pb-5 mt-4" },
                    [
                      _vm.hasRemovedPractics && _vm.filter == ""
                        ? _c(
                            "badger-accordion-item",
                            { attrs: { id: "id_closed" } },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _vm.hasRemovedPractics
                                    ? _c(
                                        "h5",
                                        { staticClass: "text-left black" },
                                        [
                                          _vm._v(
                                            "\n                Pratiche Eliminate\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasRemovedPractics
                                    ? _c(
                                        "p",
                                        { staticClass: "text-left black" },
                                        [
                                          _vm._v(
                                            "\n                Attenzione! i dati della dashboard non includono il valori di\n                pratiche eliminate.\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                {
                                  staticClass: "bbaLightColor",
                                  slot: "content"
                                },
                                [
                                  _c(
                                    "badger-accordion",
                                    { staticClass: "pb-5 mt-4 greyBg" },
                                    _vm._l(_vm.practicesFiltred, function(
                                      item,
                                      key
                                    ) {
                                      return item.status == 10
                                        ? _c(
                                            "badger-accordion-item",
                                            {
                                              key: item.code + "12",
                                              staticClass: "greyBg"
                                            },
                                            [
                                              _c(
                                                "template",
                                                {
                                                  staticClass: "greyBg",
                                                  slot: "header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row justify-content-center"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-9 text-center text-md-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Pratica N.\n                          "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.code
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " del\n                          " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .moment(
                                                                        item.created_at
                                                                      )
                                                                      .format(
                                                                        "DD-MM-YYYY HH:mm"
                                                                      )
                                                                  ) +
                                                                  "\n                          ( " +
                                                                  _vm._s(
                                                                    item.bonus
                                                                  ) +
                                                                  " ) per\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      item.client_name
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      item.client_lastname
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "btn btn-primary m-2 btn-sm",
                                                              attrs: {
                                                                href:
                                                                  item.signed_order,
                                                                target: "_blank"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "eye",
                                                                    size: "sm"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                          visualizza Preventivo Firmato\n                        "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "col-md-3 center pt-3"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                {
                                                  staticClass: "greyBg",
                                                  slot: "content"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-9 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Indirizzo dell'immobile\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.building_address
                                                                  ) +
                                                                    "\n                            " +
                                                                    _vm._s(
                                                                      item.building_civic
                                                                    ) +
                                                                    " -\n                            " +
                                                                    _vm._s(
                                                                      item.building_zip
                                                                    ) +
                                                                    "\n                            " +
                                                                    _vm._s(
                                                                      item.building_city
                                                                    ) +
                                                                    " (" +
                                                                    _vm._s(
                                                                      item.building_province
                                                                    ) +
                                                                    ")\n                          "
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Dati dell'intervento"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "\n                        Tipo:\n                        "
                                                          ),
                                                          _c("b", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "uppercase Regular"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.intervention_type
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0 text-left widthFull"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Da Cliente:\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                            €\n                            " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        parseFloat(
                                                                          item.total_transfer_for_client
                                                                        )
                                                                      )
                                                                    )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0 text-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Da Cessione:\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                            €\n                            " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        parseFloat(
                                                                          item.total_transfer_for_user
                                                                        )
                                                                      )
                                                                    )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0 text-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Totale:\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                            €\n                            " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        parseFloat(
                                                                          item.total_transfer_for_client
                                                                        ) +
                                                                          parseFloat(
                                                                            item.total_transfer_for_user
                                                                          )
                                                                      )
                                                                    )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v("Data:")
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "uppercase"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .moment(
                                                                          item.intervention_date
                                                                        )
                                                                        .format(
                                                                          "DD-MM-YYYY"
                                                                        )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5"
                },
                [
                  _c("h5", { staticClass: "center" }, [
                    _vm._v("Nessun risultato per " + _vm._s(_vm.filter))
                  ])
                ]
              )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("h3", { staticClass: "Regular center h0 widthFull" }, [
        _c("b", [_vm._v("Le tue pratiche ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 col-md-3 Bold" }, [
      _c("p", [
        _vm._v(
          "\n          * Il valore del credito cedibile e il valore del credito ceduto sono\n          aggiornati agli ultimi 10 giorni\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "d-none d-md-inline white" }, [
      _vm._v("\n            richiesta a A"),
      _c(
        "span",
        { staticStyle: { "text-transform": "lowercase !important" } },
        [_vm._v("d")]
      ),
      _vm._v("E")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe741b42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe741b42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pratiche/index.vue
// module id = null
// module chunks = 